/* fs-menu-click.js — desktop dropdowns open from THE WHOLE PILL, not on hover.

   ---- THIS SETTING HAS BEEN FLIPPED TWICE. READ BEFORE FLIPPING IT AGAIN ----
   2026-09-01: changed FROM whole-pill TO arrow-only, because a parent item's
   own landing page had become unreachable except by cmd-clicking.
   2026-09-06: changed BACK to whole-pill, by Ezra, after measuring two things
   the first change did not check:

     1. THE PARENT LINKS ARE DUPLICATES. Both tier-1 parents already appear as
        the FIRST ENTRY of their own dropdown, at the same href:
          Shop     -> /collections/shop-all   = child "Shop All"
          Magazine -> /blogs/video            = child "Films"
        So the label link was never the only route to those pages; it was a
        second route to a page listed one tap away inside the panel it opens.

     2. THE ARROW IS A 22px TARGET. Measured at 1440: the Magazine pill is
        369px wide and its arrow button is 22 — six per cent of what looks
        clickable. Shop is 215/22. On the mobile bar it is 30px inside a 149px
        item, under both the 44px iOS and 48dp Android minimums. People tap the
        label, because the label is what looks like the control, and get taken
        somewhere they did not ask to go.

   Usal does the same thing and their DOM says why it is coherent: their
   dropdown items ("Events", "Shop") are <button> with NO href at all, while
   their flat items ("Connect", "Agency", "Satellite") are buttons wrapping a
   link. An item either goes somewhere or opens something — never both.

   WE KEEP ONE ESCAPE HATCH they do not have: the label is still a real
   <a href>, and cmd/ctrl/shift/alt/middle-click still navigates, because the
   modifier guard below returns before preventDefault. Costs nothing and keeps
   "open the section page in a new tab" available to anyone who wants it.

   If you are about to flip this back a third time, the thing to check first is
   whether those parent hrefs are still duplicated inside their own panels. If
   a parent ever gets a landing page that is NOT in its dropdown, this decision
   changes — and the better fix then is to add that page to the dropdown, not
   to hand the label a second job.

   HOW THE THEME OPENS A MENU
   Symmetry adds `navigation__item--show-children` to the tier-1 <li>; main.css
   does the rest:

     .navigation .navigation__item--show-children .navigation__tier-2-container {
       visibility: visible; z-index: 11; opacity: 1; pointer-events: auto; }

   It adds that class from its own JS on hover.

   THREE LAYERS OF DEFENCE
   1. The desktop nav's pointer events are swallowed in the capture phase, so the
      theme's hover handlers never run at all (see onHoverCapture).
   2. A MutationObserver reverts anything the theme still manages to write that
      disagrees with our state — a backstop for code paths reached some other way
      (timers already queued, focus, its own resize work).
   3. Everything VISUAL keys on `fs-menu-open`, a class this file writes and
      nothing else does. Even if the theme gets a write through, it cannot make
      the nav change appearance.

   Desktop only. The mobile drawer is separate markup (.mobile-navigation-drawer)
   and is excluded by every selector here — its accordion is untouched. */
(function () {
  var OPEN = 'navigation__item--show-children';
  var WITH_CHILDREN = 'navigation__item--with-children';
  var MINE = 'fs-menu-open';   // ours alone — see apply()
  var LISTS = '.navigation--left .navigation__tier-1,' +
              ' main-navigation .navigation--main .navigation__tier-1';

  var desktop = window.matchMedia('(min-width: 768px)');

  /* The INDEX of the open item within its tier-1 list, not the element itself.
     The theme renders the desktop nav twice and swaps which copy is live; an
     index keeps both copies in step, so an open menu survives a swap. -1 means
     everything is closed. */
  var openIndex = -1;
  var applying = false;

  function lists() { return document.querySelectorAll(LISTS); }

  /* THE WHOLE-NAV FLASH.
     On hover the theme puts `section-header--nav-hover` on the .section-header
     wrapper. Every one of main.css's transparent-header rules is written
     `:not(.section-header--nav-hover):not(.section-header--nav-open)`, so that
     single class flips the ENTIRE header out of transparent mode at once —
     background, nav colour, and the white/black logo swap. Sweeping the mouse
     along the bar therefore strobed the whole thing.

     Hover must change nothing now, so that class is never allowed to stand. The
     open state still needs the solid treatment (white nav over the white blur
     sheet would be invisible), so `--nav-open` is set from OUR state instead of
     the theme's.

     Both writes MUST be guarded by a contains() check. DOMTokenList.remove()
     rewrites the class attribute even when the token was not there, which fires
     this file's own observer, which calls apply() again — an unguarded remove()
     here froze the renderer solid in an infinite microtask loop. */
  function applyHeaderState() {
    var section = document.querySelector('.section-header');
    if (!section) return;
    var want = (openIndex !== -1);
    if (section.classList.contains('section-header--nav-hover')) {
      section.classList.remove('section-header--nav-hover');
    }
    if (section.classList.contains('section-header--nav-open') !== want) {
      section.classList.toggle('section-header--nav-open', want);
    }
  }

  function apply() {
    applying = true;
    applyHeaderState();
    Array.prototype.forEach.call(lists(), function (list) {
      Array.prototype.forEach.call(list.children, function (li, i) {
        if (!li.classList.contains(WITH_CHILDREN)) return;
        var want = (i === openIndex);
        if (li.classList.contains(OPEN) !== want) li.classList.toggle(OPEN, want);
        /* MINE is the class the visuals key on. `navigation__item--show-children`
           and `aria-expanded` are both things the THEME also writes, so anything
           of ours that keyed on them could be flipped on and off by a theme code
           path we had not blocked — which would read as the nav pulsing. */
        if (li.classList.contains(MINE) !== want) li.classList.toggle(MINE, want);
        /* aria-expanded goes on BOTH controls now, because both of them expand:
           the label and the arrow are one target as far as a visitor is
           concerned, and a screen reader should hear the same thing whichever
           one it lands on. */
        var btn = li.querySelector('.fs-nav-toggle');
        if (btn) btn.setAttribute('aria-expanded', want ? 'true' : 'false');
        var lbl = li.querySelector(':scope > .navigation__link');
        if (lbl) lbl.setAttribute('aria-expanded', want ? 'true' : 'false');
      });
    });
    applying = false;
  }

  function close() {
    if (openIndex === -1) return;
    openIndex = -1;
    apply();
    /* main.css also opens on :focus-within once the visitor has pressed Tab
       (body.tab-used). The click just gave the control focus, so without this
       the panel would spring straight back open. */
    var active = document.activeElement;
    if (active && active.closest && active.closest('.' + WITH_CHILDREN)) active.blur();
  }

  function toggleItem(li, list) {
    var i = Array.prototype.indexOf.call(list.children, li);
    openIndex = (openIndex === i) ? -1 : i;
    apply();
  }

  /* REVERTING THE THEME'S HOVER IS NOT ENOUGH — IT HAS TO BE PREVENTED.
     Cleaning up afterwards still let the theme act first, and it acts more than
     once per hover: measured FOUR class flips on .section-header for a single
     mouse-over. Each add+remove pair restarts the header's colour transition.

     WHERE THE THEME LISTENS: on the `main-navigation` ELEMENT — a `mouseenter`
     on the whole nav row, not on the individual items. Scoping the block to the
     tier-1 <li>s therefore did nothing; the count only went 4 -> 0 once the
     containers themselves were covered.

     Deliberately NOT swallowed: anything inside .navigation__tier-2-container,
     so the open panel's hover images keep working; anything in the mobile
     drawer; and `click`, which is what actually opens a menu now.
     Known cost: fs-megamenu.js pre-warms the hover images on nav hover, and that
     listener is inside this net, so the first open loads its image live. The
     panel fades in over 0.28s, which covers it.

     CSS :hover is not an event, so the pills' own hover wash is unaffected. */
  var HOVER_EVENTS = ['pointerover', 'pointerenter', 'pointerout', 'pointerleave',
                      'mouseover', 'mouseenter', 'mouseout', 'mouseleave', 'focusin'];

  function onHoverCapture(e) {
    if (!desktop.matches || !e.target.closest) return;
    if (e.target.closest('.navigation__tier-2-container')) return;
    if (e.target.closest('.mobile-navigation-drawer')) return;
    if (!e.target.closest('main-navigation.desktop-only, .navigation--left')) return;
    e.stopPropagation();
  }

  function onClickCapture(e) {
    if (!desktop.matches || !e.target.closest) return;

    /* --- the arrow pill --------------------------------------------------- */
    var btn = e.target.closest('.fs-nav-toggle');
    if (btn) {
      var btnLi = btn.parentElement;
      var btnList = btnLi && btnLi.parentElement;
      if (!btnList || !btnList.matches(LISTS)) return;
      e.preventDefault();
      e.stopPropagation();   // also stops the outside-click listener below
      toggleItem(btnLi, btnList);
      if (openIndex === -1 && btn.blur) btn.blur();
      return;
    }

    /* --- the label pill: same job as the arrow ---------------------------- */
    var link = e.target.closest('.navigation__link');
    if (!link) return;

    var li = link.parentElement;
    if (!li || !li.classList.contains(WITH_CHILDREN)) return;

    /* Must be a TIER-1 item of a desktop nav. Links inside the open panel are
       tier-2 and have to navigate normally. */
    var list = li.parentElement;
    if (!list || !list.matches(LISTS)) return;

    /* THE ESCAPE HATCH — leave this above the preventDefault. A modified or
       non-primary click still navigates to the section page, so anyone who
       wants it in a new tab can still have it. */
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;

    /* A plain click on a parent label OPENS THE PANEL and does not navigate.
       There is no href test here any more: the parent's own page is the first
       entry inside the panel this opens, so nothing becomes unreachable. */
    e.preventDefault();
    e.stopPropagation();
    toggleItem(li, list);
    if (openIndex === -1 && link.blur) link.blur();
  }

  function init() {
    HOVER_EVENTS.forEach(function (type) {
      document.addEventListener(type, onHoverCapture, true);
    });

    /* Capture phase, so the theme's own click handling never sees these. */
    document.addEventListener('click', onClickCapture, true);

    /* Anything else closes. Tier-1 clicks never reach here — the capture
       handler above stops them — so this is every other click on the page,
       including links inside the open panel. */
    document.addEventListener('click', close);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' || e.keyCode === 27) close();
    });

    if (window.MutationObserver) {
      var mo = new MutationObserver(function () { if (!applying) apply(); });
      Array.prototype.forEach.call(lists(), function (list) {
        mo.observe(list, { attributes: true, attributeFilter: ['class'], subtree: true });
      });
      /* The wrapper is an ancestor of the nav lists, so it needs its own
         observation — a subtree observer on the list never sees it. */
      var section = document.querySelector('.section-header');
      if (section) mo.observe(section, { attributes: true, attributeFilter: ['class'] });
    }

    applyHeaderState();   // clear any --nav-hover left over from before we loaded

    /* Crossing the breakpoint hands over to the mobile drawer; don't leave a
       desktop panel flagged open behind it. */
    if (desktop.addEventListener) desktop.addEventListener('change', close);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();